import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
} from '@angular/core';
import {
  KbAnalyseItemResponse,
  PreorderAvailabilityStatus,
} from '@medindex-webapi';
import { HelixBookRepositoryService } from '../../services/helix-book-repository.service';
import { map } from 'rxjs';
import { trigger, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-helixbook-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('flyInOut', [
      transition('void => *', [
        style({ transform: 'translateY(-100%)' }),
        animate(200),
      ]),
      transition('* => void', [
        animate(200, style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class PriceComponent {
  @Input() item: KbAnalyseItemResponse | null = null;
  showMobile = false;

  constructor(private repository: HelixBookRepositoryService) {}

  get isAvailable(): boolean {
    return (
      this.item?.preorderAvailability !==
      PreorderAvailabilityStatus.NotAvailable
    );
  }

  inCart$ = this.repository.cartHxids$.pipe(
    map((hxids) => hxids.includes(this.item?.hxid ?? ''))
  );

  @HostListener('window:scroll', ['$event']) onScroll(): void {
    this.showMobile = window.scrollY > 600;
  }

  addToCart(): void {
    if (this.item?.hxid) {
      this.repository.addToCart(this.item.hxid);
    }
  }
}
